// The goal of this file is to mark the beginning of the app's reading
// it should be imported as the first import of index.tsx
// don't import or require any other file here
// don't add any costly operation here

export {};
try {
    performance.mark('app-read-start');
} catch (error) {}
